/* app/js/src/components/common/hover-button/hover-button.component.scss */
:host(.disabled) {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
:host(.disabled) .container:hover {
  background-color: inherit !important;
}
.container {
  padding: 0 5px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.container:hover {
  background-color: #40c4ff !important;
}
.container.transparent:hover {
  background-color: transparent !important;
}
.container.grey:hover {
  background-color: #dde3e7 !important;
}
/*# sourceMappingURL=hover-button.component.css.map */
